<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="flex flex-col mt-2">
    <label for="name" class="soft-label top required">{{
      '#TICKETS.DIALOGS.EDIT.NAME' | translate
    }}</label>
    <soft-input formControlName="name" id="name"></soft-input>
    @if (form.controls['name'].touched) {
      <soft-validation-container
        [validation]="form | validationMessage: 'name'"
        class="soft-property-validation"
      ></soft-validation-container>
    }
  </div>
  <div class="flex flex-col mt-2">
    <div class="flex flex-row justify-between">
      <label for="priority" class="soft-label top required">{{
        '#TICKETS.DIALOGS.EDIT.PRIORITY' | translate
      }}</label>
      <span class="hint">{{ '#TICKETS.CREATE.PRIORITY_HINT' | translate }}</span>
    </div>
    <soft-select id="priority" formControlName="priority">
      <soft-select-option *softRepeat="9; let i = index" [value]="i + 1"
        >{{ i + 1 }} -
        {{ '#TICKETS.PRIORITIES.' + (i + 1) | translate }}</soft-select-option
      >
    </soft-select>
    @if (form.controls['priority'].touched) {
      <soft-validation-container
        [validation]="form | validationMessage: 'priority'"
        class="soft-property-validation"
      ></soft-validation-container>
    }
  </div>

  <div class="flex flex-col mt-2">
    <label for="deadline" class="soft-label top">{{
      '#TICKETS.DIALOGS.EDIT.DUE' | translate
    }}</label>
    <soft-date-input
      formControlName="deadline"
      id="deadline"
      [readonly]="true"
    ></soft-date-input>
    <!-- @if (form.controls['deadline'].touched) {
      <soft-validation-container
        [validation]="form | validationMessage: 'deadline'"
        class="soft-property-validation"
      ></soft-validation-container>
    } -->
  </div>

  @if (isEditor()) {
    <div class="flex flex-col mt-2">
      <label for="type" class="soft-label top required">{{
        '#TICKETS.DIALOGS.EDIT.TYPE' | translate
      }}</label>
      <soft-select id="type" formControlName="type">
        @for (type of ticketTypes$ | async; track type) {
          <soft-select-option [value]="type.id" [innerHTML]="type.description">
          </soft-select-option>
        }
        @if (ticket()?.type && !($safeNavigationMigration(ticket()?.type) | in: (ticketTypes$ | async))) {
          <soft-select-option
            [value]="$safeNavigationMigration(ticket()?.type?.id)"
            [innerHTML]="$safeNavigationMigration(ticket()?.type?.description)"
          >
          </soft-select-option>
        }
      </soft-select>
      @if (form.controls['type'].touched) {
        <soft-validation-container
          [validation]="form | validationMessage: 'type'"
          class="soft-property-validation"
        ></soft-validation-container>
      }
    </div>
    <div class="flex flex-col mt-2">
      <label for="cobitCategory" class="soft-label top">{{
        '#TICKETS.DIALOGS.EDIT.COBIT_CATEGORY' | translate
      }}</label>
      <soft-value-converter
        formControlName="cobitCategory"
        [converter]="cobitkatValueConverter"
      >
        <soft-field-ok
          fieldOkName="ticketcobitkat"
          id="cobitCategory"
          #convertValue
        ></soft-field-ok>
      </soft-value-converter>
      @if (form.controls['cobitCategory'].touched) {
        <soft-validation-container
          [validation]="form | validationMessage: 'cobitCategory'"
          class="soft-property-validation"
        ></soft-validation-container>
      }
    </div>
    <div class="flex flex-col mt-2">
      <label for="rfcCategory" class="soft-label top">{{
        '#TICKETS.DIALOGS.EDIT.RFC_CATEGORY' | translate
      }}</label>
      <soft-select id="rfcCategory" formControlName="rfcCategory">
        <soft-select-option value="X">{{
          '#TICKETS.RFC_CATEGORIES.UNDEFINED' | translate
        }}</soft-select-option>
        <soft-select-option value="E">{{
          '#TICKETS.RFC_CATEGORIES.DEVELOPMENT' | translate
        }}</soft-select-option>
        <soft-select-option value="F">{{
          '#TICKETS.RFC_CATEGORIES.ACCOUNTING' | translate
        }}</soft-select-option>
        <soft-select-option value="W">{{
          '#TICKETS.RFC_CATEGORIES.PRODUCT_MANAGEMENT' | translate
        }}</soft-select-option>
      </soft-select>
      @if (form.controls['cobitCategory'].touched) {
        <soft-validation-container
          [validation]="form | validationMessage: 'cobitCategory'"
          class="soft-property-validation"
        ></soft-validation-container>
      }
    </div>
    <div class="flex flex-col mt-2">
      <label for="object" class="soft-label top">{{
        '#TICKETS.DIALOGS.EDIT.OBJECT' | translate
      }}</label>
      <soft-value-converter formControlName="object" [converter]="objektValueConverter">
        <soft-field-ok
          fieldOkName="objekt"
          [parameters]="{ idktostamm_kunde: getAccountId() }"
          id="object"
          #convertValue
        ></soft-field-ok>
      </soft-value-converter>
      @if (form.controls['object'].touched) {
        <soft-validation-container
          [validation]="form | validationMessage: 'object'"
          class="soft-property-validation"
        ></soft-validation-container>
      }
    </div>
    <div class="flex flex-col mt-2">
      <label for="costCenter" class="soft-label top">{{
        '#TICKETS.DIALOGS.EDIT.COST_CENTER' | translate
      }}</label>
      <soft-value-converter
        formControlName="costCenter"
        [converter]="costcenterValueConverter"
      >
        <soft-field-ok
          fieldOkName="kst"
          [parameters]="{ OBJEKT: $safeNavigationMigration(form.value.object?.number) }"
          id="costCenter"
          #convertValue
        ></soft-field-ok>
      </soft-value-converter>
      @if (form.controls['costCenter'].touched) {
        <soft-validation-container
          [validation]="form | validationMessage: 'costCenter'"
          class="soft-property-validation"
        ></soft-validation-container>
      }
    </div>
    @if (ticket()?.type?.name === 'Release' && (isReleaseEditor())) {
      <ng-container formGroupName="release">
        <div class="flex flex-col mt-2">
          <label for="releasestart_beta" class="soft-label top">{{
            '#TICKETS.DIALOGS.EDIT.RELEASE_TEST_START' | translate
          }}</label>
          <soft-date-time-input
            formControlName="releasestart_beta"
            id="releasestart_beta"
          ></soft-date-time-input>
        </div>
        <div class="flex flex-col mt-2">
          <label for="releaseduration_beta" class="soft-label top">{{
            '#TICKETS.DIALOGS.EDIT.RELEASE_TEST_DURATION' | translate
          }}</label>
          <soft-duration-input
            formControlName="releaseduration_beta"
            id="releaseduration_beta"
          ></soft-duration-input>
        </div>
        <div class="flex flex-col mt-2">
          <label for="releasestart_original" class="soft-label top">{{
            '#TICKETS.DIALOGS.EDIT.RELEASE_ORIG_START' | translate
          }}</label>
          <soft-date-time-input
            formControlName="releasestart_original"
            id="releasestart_original"
          ></soft-date-time-input>
        </div>
        <div class="flex flex-col mt-2">
          <label for="releaseduration_original" class="soft-label top">{{
            '#TICKETS.DIALOGS.EDIT.RELEASE_ORIG_DURATION' | translate
          }}</label>
          <soft-duration-input
            formControlName="releaseduration_original"
            id="releaseduration_original"
          ></soft-duration-input>
        </div>
      </ng-container>
    }
  }
  <div class="flex flex-row justify-end mt-2">
    <button
      type="submit"
      [disabled]="!(form | isValid)"
      class="soft-button soft-button-primary rounded hover:cursor-pointer"
    >
      {{ '#TICKETS.DIALOGS.EDIT.SUBMIT' | translate }}
    </button>
  </div>
</form>
